<template>
  <div class="legal-rules">
    <LegalHeader />
    <div class="legal-rules__content">
      <h1 class="legal-rules__title">资质与协议</h1>
      <LegalSearch @search="handleSearch" />
      <div v-if="loading" class="legal-rules__loading">加载中...</div>
      <div v-else class="legal-rules__categories">
        <LegalCategory
          v-for="(item, index) in items"
          :key="index"
          :category="item"
          :is-search-mode="isSearchMode"
        />
        <div v-if="isSearchMode && items.length === 0" class="legal-rules__empty">
          抱歉，未能找到相关内容
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import zzfetch from '@zz/fetch'
import LegalHeader from '@/components/LegalRules/LegalHeader.vue'
import LegalSearch from '@/components/LegalRules/LegalSearch.vue'
import LegalCategory from '@/components/LegalRules/LegalCategory.vue'

interface SecondItem {
  title: string
  jumpUrl: string
}

interface CategoryItem {
  title: string
  secondItems: SecondItem[]
}

export default Vue.extend({
  name: 'LegalRules',
  components: {
    LegalHeader,
    LegalSearch,
    LegalCategory
  },
  data() {
    return {
      items: [] as CategoryItem[],
      loading: false,
      keyword: '',
      fetchId: 0
    }
  },
  computed: {
    isSearchMode(): boolean {
      return this.keyword.length > 0
    }
  },
  mounted() {
    document.title = '资质与协议'
    this.fetchData()
  },
  methods: {
    async fetchData(searchK?: string) {
      this.loading = true
      const currentFetchId = ++this.fetchId
      try {
        const params: Record<string, string> = {}
        if (searchK) {
          params.searchK = searchK
        }
        const res = await zzfetch({
          url: 'https://app.zhuanzhuan.com/api/zzlogic/getPcLegalRules',
          params,
          method: 'POST'
        })
        if (currentFetchId !== this.fetchId) return
        if (res.respCode === 0) {
          let items: CategoryItem[] = res.respData?.items || []

          if (searchK) {
            items = items.filter(
              (item: CategoryItem) =>
                Array.isArray(item.secondItems) && item.secondItems.length > 0
            )
          }

          this.items = items
        }
      } catch (e) {
        if (currentFetchId !== this.fetchId) return
        this.items = []
      } finally {
        if (currentFetchId === this.fetchId) {
          this.loading = false
        }
      }
    },
    handleSearch(keyword: string) {
      this.keyword = keyword
      if (keyword) {
        this.fetchData(keyword)
      } else {
        this.fetchData()
      }
    }
  }
})
</script>

<style scoped lang="scss">
.legal-rules {
  min-height: 100vh;
  background: #fff;

  /* 保持中间内容 px 不变，整体最小宽度调大，避免小屏字体过小 */
  min-width: 1200px;

  &__content {
    width: 880px;
    margin: 0 auto;
    padding-bottom: 60px;
  }

  &__title {
    font-family: 'PingFang SC', sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 100%;
    color: rgba(0, 0, 0, 0.88);
    margin: 0;
    padding: 32px 0;
  }

  &__loading {
    text-align: center;
    padding: 60px 0;
    font-size: 14px;
    color: #999;
  }

  &__categories {
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  &__empty {
    padding-left: 24px;
    font-family: 'PingFang SC', sans-serif;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    letter-spacing: normal;
    color: #111111;
  }
}

/* 小屏时整体等比放大（字号、间距、按钮等所有带单位的样式一起放大） */
@media (max-width: 1800px) {
  .legal-rules {
    transform: scale(1.2);
    transform-origin: top center;
  }
}
</style>
